import { defineMessages } from 'react-intl';

const _default_1: {
	logo: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	logo: {
		id: 'fabric.editor.ai.commandPalette.promptForm.logo',
		defaultMessage: 'Atlassian Intelligence Logo',
		description: 'Atlassian Intelligence logo alt text',
	},
});
export default _default_1;
